<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { Switch } from '@headlessui/vue'
import { MoonIcon, SunIcon } from '@heroicons/vue/24/outline'
import { useUserStore } from '~/store/UserStore'

const userStore = useUserStore()
const { t } = useI18n()
const colorMode = useColorMode()
const isDark = computed({
  get: () => colorMode.value === 'dark',
  set: (val: boolean) => changeTheme(val),
})
const loading = ref(false)
async function changeTheme(val: boolean) {
  const newTheme = val ? 'dark' : 'light'
  loading.value = true
  await userStore.setTheme(newTheme)
  await userStore.setColorMode()
  loading.value = false
}
</script>

<template>
  <Switch
    v-model="isDark"
    :disabled="loading"
    class="toggle-with-text dark:bg-slate-600 bg-slate-300"
    :aria-label="isDark ? t('DARK') : t('LIGHT')"
    @update:model-value="changeTheme"
  >
    <span
      aria-hidden="true"
      :class="{
        'translate-x-5': isDark,
        'translate-x-.5': !isDark,
      }"
    >
      <span
        :class="{
          'opacity-0 duration-100 ease-out': !isDark,
          'opacity-100 duration-200 ease-in': isDark,
        }"
        class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
        aria-hidden="true"
      >
        <MoonIcon
          class="text-slate-900 h-3.5 w-3.5"
          aria-hidden="true"
        />
      </span>
      <span
        :class="{
          'opacity-100 duration-200 ease-in': !isDark,
          'opacity-0 duration-100 ease-out': isDark,
        }"
        class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
        aria-hidden="true"
      >
        <SunIcon
          class="text-slate-900 h-3.5 w-3.5"
          aria-hidden="true"
        />
      </span>
    </span>
  </Switch>
</template>
